class History {
    static history = null;
    static get item () {
        return History.history;
    }
    static set item(history) {
        History.history = history;
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/modules/History.js